// extracted by mini-css-extract-plugin
module.exports = {"RulesPanel":"RulesPanel_RulesPanel__2M6dY","IconImage":"RulesPanel_IconImage__1Bp1x","KendoGrid":"RulesPanel_KendoGrid__3qWuM"};